import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { INotasFiscaisReport } from '../interfaces/notasFiscaisReport/inotasfiscaisreport';

@Injectable({
  providedIn: 'root'
})
export class NotasFiscaisReportService {

  /* url: string = 'http://localhost:3000/notas_fiscais_report'; */

   url: string = 'https://api-fake-r9p5.onrender.com/notas_fiscais_report'; 

  constructor(private http: HttpClient) { }

  get() {
    return this.http
      .get(this.url)
      .pipe(map((res: any) => res)) as Observable<INotasFiscaisReport>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<INotasFiscaisReport>;
  }

}
